import { css } from '@emotion/core';

export const pageFrameWithOverlayCSS = css`
    display: none;
`;

export const pageFrameWithChildrenCSS = css`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
